<template>
	<div>
		<DataviewComponent 
			v-if="templateData.data_view" 
			:templateData="templateData"
			@refresh="refreshDataview"
			/>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import DataviewComponent from '@vueapp/components/DataviewComponent.vue'

declare global {
    interface Window {
        fe_theme:any;
        BRYTER:any;
    }
}

const BRYTER = window.BRYTER

export default defineComponent({
    name: 'VueDataview',
	components: {
		DataviewComponent
	},
	props: [
        'postSlug',
    ],
	async beforeMount() {
        const params = new URLSearchParams(window.location.search),
            eParams = {}
        params.forEach((value, name) => {
            if ( ! name.match(/env|debug/) && value.match(/^([a-z0-9\_\-\+]+)$/) ) {
                eParams[name] = value
            }
        });

        let paramsString = ( new URLSearchParams(eParams) ) .toString()

        // console.log('dataview postSlug::', this.postSlug)
		// console.log(BRYTER.homeUrl + '/data-view/' + this.postSlug + '/?env=' + BRYTER.envId + '&json')

	    fetch( BRYTER.homeUrl + '/data-view/' + this.postSlug + '/?env=' + BRYTER.envId + '&json&t=' + Date.now() + '&' + paramsString)
      		.then(response => response.json())
      		.then(data => {
      			data.database_columns_data = data.database_columns_data.map(item => {
        			item.show = true
        			return item
        		})
        		data.database_columns = data.database_columns.map(item => {
        			item.sort = {
				                    dir: 0
				                }
        			return item
        		})
        		this.templateData = data

        		// this.loading = false
      		})
  	},
	data() {
		return {
			loading: true,
			templateData: [],
		}
	},

	methods: {
		async refreshDataview( evt ) {
            // console.log('filters::', this.filters)
            let sorting = evt.sorting,
            	filters = evt.filters
            let payload = { 
                    params : {
                        dt_id: this.templateData.data_view.id,
                        post_id: this.templateData.data_view.id,
                        ...filters,
                        sorting
                    },
                    
                }

            await fetch( BRYTER.ajaxUrl + '?action=tableFilter&env=' + BRYTER.envId + '&json&' + this.toQueryString(payload) )
            .then(response => response.json())
            .then(data => {
                // console.log('refreshDataview data::', data);
                data.database_columns_data = data.database_columns_data.map(item => {
                    item.show = true
                    return item
                })
                data.database_columns = data.database_columns.map( item => {
                	item.sort = {
						dir: sorting.columnName == item.column_name ? (sorting.sortOrder == 'asc' ? 1 : -1) : 0
        			}       
                    return item	
                })
                this.templateData.database_columns_data = data.database_columns_data
                this.templateData.database_columns = data.database_columns

                // this.loading = false
            })
        },
        toQueryString(obj, prefix) {
            var str = [], k, v;
            for(var p in obj) {
                if (!obj.hasOwnProperty(p)) {continue;} // skip things from the prototype
                if (~p.indexOf('[')) {
                    k = prefix ? prefix + "[" + p.substring(0, p.indexOf('[')) + "]" + p.substring(p.indexOf('[')) : p;
                    // only put whatever is before the bracket into new brackets; append the rest
                } else {
                    k = prefix ? prefix + "[" + p + "]" : p;
                }
                v = obj[p];
                str.push(typeof v == "object" ?
                  this.toQueryString(v, k) :
                  encodeURIComponent(k) + "=" + encodeURIComponent(v));
            }
            return str.join("&");
        },
	}
})
</script>